import { MODAL_NAMES } from '#client/constants/modals';
import useCardsContext from '#client/hooks/useCardsContext';
import useModalContext from '#client/hooks/useModalContext';

export default function useUnfreezeCard() {
  const { virtualCard } = useCardsContext();
  const { openModal } = useModalContext();
  const { id: cardId, last4Digits } = virtualCard || {};

  const unfreezeCard = () => {
    openModal({
      name: MODAL_NAMES.UNFREEZE_CARD_MODAL,
      cardId,
      last4Digits
    });
  };

  return {
    unfreezeCard
  };
}
